import React from 'react';
import { withIsMobile } from 'treeline-react-core-components/WindowSizeProvider';
import { connectToCollections } from '../../Collections/containers/CollectionsDataStore';
import { connectToTitle } from '../../Title/containers/TitleDataStore';
import Scroller from '../../UI/Scroller/Scroller';
import combineConnectors from '../../util/combineConnectors';
import { connectToShelves } from '../containers/ShelvesDataStore';
import ShelfType from '../ShelfType';
import '../stackScroller.css';
import './shelves.css';

export class StackScrollerHorizontal extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		const { allowMultipleSelections, selectedStack } = this.props;
		const doHideDivider = !allowMultipleSelections && selectedStack.key;
		return (
			<React.Fragment>
				<div
					className="stacks"
					style={{ paddingBottom: '10px', marginTop: '5px' }}>
					<div className="shelf-scroller">
						<Scroller>
							<>
								{this.renderShelfBookstop(
									ShelfType.AnticipatingMild,
								)}
								{this.renderShelfBookstop(
									ShelfType.AnticipatingHigh,
								)}
								{this.renderShelfBookstop(
									ShelfType.CurrentlyReading,
								)}
								{this.renderShelfBookstop(
									ShelfType.FinishedReading,
								)}
								{this.renderShelfBookstop(
									ShelfType.DidntFinish,
								)}
								{this.renderShelfBookstop(ShelfType.Favorites)}
								{!doHideDivider && this.renderDivider()}
								{this.renderCollections()}
								{this.props.children}
							</>
						</Scroller>
					</div>
				</div>
			</React.Fragment>
		);
	}

	renderDivider = () => {
		return (
			<div className="book-stop-divider">
				<div
					className="icon-chevron-left"
					style={{ marginLeft: '3px' }}
				/>
				<div
					style={{
						height: '105px',
						overflow: 'hidden',
						marginTop: '-5px',
					}}>
					<div className="bookstop-text">
						<div
							className="dotDot"
							style={{
								width: '100px',
								overflow: 'hidden',
								marginTop: '10px',
								fontSize: '12px',
							}}>
							<span>
								Set&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;&nbsp;&nbsp;Custom
							</span>
						</div>
					</div>
				</div>
				<div
					className="icon-chevron-right"
					style={{ marginLeft: '3px' }}
				/>
			</div>
		);
	};

	renderCollections = () => {
		const { collections } =
			this.props.collectionsDataStore &&
			this.props.collectionsDataStore.state;
		return (
			collections &&
			collections.length > 0 &&
			collections.map((collection, idx) => (
				<React.Fragment key={`${collection.catalogID}-${idx}`}>
					{this.renderStack(
						null,
						collection.name,
						collection.titleCount,
						'collection',
						collection.catalogID,
					)}
				</React.Fragment>
			))
		);
	};

	renderShelfBookstop = shelfType => {
		const { shelves } =
			this.props.shelvesDataStore && this.props.shelvesDataStore.state;
		return (
			<React.Fragment>
				{this.renderStack(
					shelfType.icon,
					shelfType.text,
					shelves &&
						shelves.filter(sh => sh.shelf === shelfType.key).length,
					'shelf',
					shelfType.key,
				)}
			</React.Fragment>
		);
	};

	renderStack = (icon, name, count, stackType, key) => {
		const { allowMultipleSelections, selectedStack } = this.props;
		const isMobile = this.props.isMobile();
		const isSelected = this.getIsSelected(stackType, key);
		const doHideStack =
			!allowMultipleSelections && !isSelected && selectedStack.key;
		return (
			<React.Fragment>
				{!doHideStack && (
					<div
						onClick={() =>
							this.clickStack(isSelected, stackType, key)
						}
						className={`clickable ${
							!isMobile
								? 'book-stop-frame'
								: 'book-stop-frame-mobile'
						} ${isSelected && 'selected-frame'}`}>
						<div
							className={`bookstop-area bookstop-${stackType}${
								isSelected ? '-selected' : ''
							}`}>
							<div className="bookstop-inner">
								<div className="stack-title-count">
									{count ? count : '-'}
								</div>
								{icon && (
									<div className={`${icon} stacks-icon`} />
								)}
								<div
									className="relative"
									style={{ height: '110px' }}>
									<div className="bookstop-text">
										<div
											className="dotDot"
											style={{
												width: `${
													icon ? '100px' : '118px'
												}`,
												overflow: 'hidden',
												marginTop: '10px',
											}}>
											{name}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				)}
			</React.Fragment>
		);
	};

	getIsSelected = (stackType, key) => {
		const { selectedStack, selectedStacks, sku } = this.props;
		if (sku) {
			if (stackType === 'shelf') {
				const { shelves } = this.props.shelvesDataStore.state;
				return (
					shelves &&
					shelves.length > 0 &&
					shelves.filter(sh => sh.sku === sku && sh.shelf === key)
						.length > 0
				);
			} else {
				const {
					isCollectionDataLoading,
					collections,
				} = this.props.titleDataStore.state;
				return (
					!isCollectionDataLoading &&
					collections &&
					collections.filter(
						cl => cl.hasFlaggedTitle && cl.catalogID === key,
					).length > 0
				);
			}
		} else {
			return (
				(selectedStacks &&
					selectedStacks.filter(
						st => st.stackType === stackType && st.key === key,
					).length > 0) ||
				(selectedStack &&
					selectedStack.stackType === stackType &&
					selectedStack.key === key)
			);
		}
	};

	clickStack = (isSelected, stackType, key) => {
		if (isSelected) {
			this.removeStack(stackType, key);
		} else {
			this.addStack(stackType, key);
		}
	};

	addStack = (stackType, key) => {
		const { allowMultipleSelections } = this.props;
		if (allowMultipleSelections) {
			var selectedStacks = this.props.selectedStacks;
			if (stackType === 'shelf') {
				selectedStacks = selectedStacks.filter(
					af => af.stackType !== stackType,
				);
			}
			var thisStack = {};
			thisStack.stackType = stackType;
			thisStack.key = key;
			selectedStacks.push({
				thisStack,
			});
			this.props.processStackClick(selectedStacks, thisStack, 'add');
		} else {
			var selectedStack = {};
			selectedStack.stackType = stackType;
			selectedStack.key = key;
			this.props.processStackClick(selectedStack);
		}
	};

	removeStack = (stackType, key) => {
		const { allowMultipleSelections } = this.props;
		if (allowMultipleSelections) {
			const selectedStacks = this.props.selectedStacks;
			const newSelectedStacks = selectedStacks.filter(
				af =>
					af.stackType != stackType ||
					(af.stackType == stackType && af.key != key),
			);
			var thisStack = {};
			thisStack.stackType = stackType;
			thisStack.key = key;
			this.props.processStackClick(
				newSelectedStacks,
				thisStack,
				'remove',
			);
		} else {
			this.props.processStackClick();
		}
	};

	toggleShelfForSingleSku = thisShelf => {
		this.setState({ selectedShelf: thisShelf });
		var skus = [];
		skus.push(this.props.sku);
		this.props.shelvesDataStore.setShelves(skus, thisShelf);
	};
}

const connectors = [connectToShelves, connectToCollections, connectToTitle];

export default combineConnectors(connectors)(
	withIsMobile(StackScrollerHorizontal),
);
